<template>
  <div class="fixed right-4 z-[100]" :class="position === 'top' ? ['top-4'] : ['bottom-4']">
    <div class="w-fit">
      <transition-group
        :enter-active-class="
          notificationsByGroup.length > 1
            ? 'transform ease-out duration-300 transition delay-500'
            : 'transform ease-out duration-300 transition'
        "
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transform ease-out duration-300 transition delay-300 opacity-0"
        leave-from-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-to-class="translate-y-2 opacity-0 sm:translate-x-4"
        move-class="transition duration-500"
      >
        <slot :notifications="sortedNotifications" :close="close" />
      </transition-group>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { UiNotification } from '@infuse/ui/domain';
import { useEmitter } from '@infuse/ui/services';
import { computed, onMounted, reactive } from 'vue';

interface Props {
  group: string;
  position?: 'top' | 'bottom';
  maxNotifications?: number;
}

const props = withDefaults(defineProps<Props>(), {
  group: '',
  position: 'top',
  maxNotifications: 10
});

const emit = defineEmits(['close']);

const emitter = useEmitter();
const notifications = reactive<UiNotification[]>([]);

onMounted(() => {
  emitter.on('notify', add);
});

const notificationsByGroup = computed((): UiNotification[] => {
  return notifications.filter((n) => n.group === props.group);
});

const sortedNotifications = computed((): UiNotification[] => {
  if (props.position === 'bottom') {
    return [...notificationsByGroup.value].slice(0, props.maxNotifications);
  }
  // if not bottom reverse the array
  return [...notificationsByGroup.value].reverse().slice(0, props.maxNotifications);
});

function add({ notification }: any): void {
  const DEFAULT_TIMEOUT = 3000;
  if (notifications) {
    notifications.push(notification);
  }

  setTimeout(() => {
    remove(notification.id);
  }, notification.timeout || DEFAULT_TIMEOUT);
}

function close(id: number): void {
  emit('close');
  remove(id);
}

function remove(id: number): void {
  notifications.splice(
    notifications.findIndex((n) => n.id === id),
    1
  );
}
</script>
